import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { formatCurrency, formatDate } from '../utils';
import { useState, useEffect } from 'react';

/**
 * Componente para exibir o histórico de pagamentos de uma parcela
 */
const HistoricoPagamento = ({ 
  open, 
  onClose, 
  historicoPagamento 
}) => {
  const theme = useTheme();
  // Forçar modo mobile definitivo
  let isMobile = false;
  if (typeof window !== 'undefined' && window.innerWidth <= 600) {
    isMobile = true;
    console.log('[HistoricoPagamento] Renderizando cards/resumo simplificado (MODO MOBILE FORÇADO)');
  }
  const [calculatedTotalJurosManuais, setCalculatedTotalJurosManuais] = useState(0);
  const [calculatedTotalJurosManuaisPercentual, setCalculatedTotalJurosManuaisPercentual] = useState(0);

  useEffect(() => {
    if (historicoPagamento && historicoPagamento.pagamentos) {
      let totalJurosManuais = 0;
      historicoPagamento.pagamentos.forEach(pagamento => {
        totalJurosManuais += (pagamento.valor_juros || 0);
      });
      setCalculatedTotalJurosManuais(totalJurosManuais);

      if (historicoPagamento.parcela && historicoPagamento.parcela.valor_original > 0) {
        const percentual = (totalJurosManuais / historicoPagamento.parcela.valor_original) * 100;
        setCalculatedTotalJurosManuaisPercentual(percentual);
      } else {
        setCalculatedTotalJurosManuaisPercentual(0);
      }
    }
  }, [historicoPagamento]);

  console.log('[HistoricoPagamento] Dados recebidos do backend:', historicoPagamento);
  console.log('[HistoricoPagamento] total_juros_manuais_percentual no resumo:', historicoPagamento?.total_juros_manuais_percentual);
  console.log('[HistoricoPagamento] juros_manuais_percentual (original da API) no resumo:', historicoPagamento?.juros_manuais_percentual);
  console.log('[HistoricoPagamento] isMobile:', isMobile, 'window.innerWidth:', typeof window !== 'undefined' ? window.innerWidth : 'N/A');
  // Verificar se temos dados para exibir
  if (!historicoPagamento) {
    console.log('HistoricoPagamento: historicoPagamento é nulo ou indefinido.');
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Histórico de Pagamento</DialogTitle>
        <DialogContent>
          <Typography>Carregando histórico...</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">FECHAR</Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (historicoPagamento.mensagem) {
    console.log('HistoricoPagamento: Mensagem de erro no histórico:', historicoPagamento.mensagem);
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Histórico de Pagamento</DialogTitle>
        <DialogContent>
          <Typography>{historicoPagamento.mensagem}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">FECHAR</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth={isMobile ? 'xs' : 'md'}
      fullWidth
      PaperProps={{
        sx: {
          '@media (max-width: 600px)': {
            minWidth: '95vw',
            maxWidth: '98vw',
            width: '98vw',
            borderRadius: 2,
            m: 'auto',
            p: 1,
            maxHeight: '90vh',
            overflowY: 'auto',
            bgcolor: '#f9f9fa',
          },
          p: { xs: 1, sm: 2 },
          maxHeight: isMobile ? '90vh' : '95vh',
          overflowY: 'auto',
        }
      }}
    >
      <DialogTitle sx={{ fontSize: { xs: '1.1rem', sm: '1.3rem' }, p: { xs: 1, sm: 2 }, textAlign: isMobile ? 'center' : 'left', color: 'green' }}>
        Histórico de Pagamento
      </DialogTitle>
      <DialogContent 
        sx={{ 
          p: { xs: 1, sm: 2 }, 
          width: isMobile ? '96vw' : 'auto',
          maxWidth: isMobile ? '96vw' : 'auto',
          maxHeight: isMobile ? '70vh' : '80vh',
          overflowY: 'auto',
          bgcolor: isMobile ? '#fff' : 'inherit',
          borderRadius: isMobile ? 2 : 0,
          m: isMobile ? 'auto' : 0
        }}
      >
        {historicoPagamento && historicoPagamento._avisoFilha && (
          <Box sx={{ mb: 2, p: 2, bgcolor: '#fffde7', border: '1px solid #ffe082', borderRadius: 2 }}>
            <Typography variant="body2" color="warning.main" fontWeight="bold">
              {historicoPagamento._avisoFilha}
            </Typography>
          </Box>
        )}
        {historicoPagamento && historicoPagamento.parcela ? (
          <Box>
            {/* MOBILE: Cards/blocos para resumo */}
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
              <Box sx={{ mb: 2, p: 2, bgcolor: '#fff', borderRadius: 2, boxShadow: 1 }}>
                <Typography variant="body2" fontWeight="bold" mb={0.5}>
                  Cliente: <span style={{ fontWeight: 'normal' }}>{historicoPagamento.parcela.emprestimo?.cliente?.nome || 'N/A'}</span>
                </Typography>
                <Typography variant="body2" fontWeight="bold" mb={0.5}>
                  Parcela: <span style={{ fontWeight: 'normal' }}>#{historicoPagamento.parcela.numero_parcela || historicoPagamento.parcela.numero || '?'}</span>
                </Typography>
                <Typography variant="body2" mb={0.5}><b>Valor Original:</b> {formatCurrency(historicoPagamento.parcela.valor_original || 0)}</Typography>
                <Typography variant="body2" mb={0.5}><b>Juros Automáticos:</b> {formatCurrency(historicoPagamento.total_juros_automaticos || 0)} ({historicoPagamento.total_juros_automaticos_percentual !== undefined ? historicoPagamento.total_juros_automaticos_percentual.toFixed(2) : '0.00'}%)</Typography>
                <Typography variant="body2" mb={0.5}><b>Juros Manuais:</b> {formatCurrency(historicoPagamento.juros_manuais_resumo !== undefined ? historicoPagamento.juros_manuais_resumo : calculatedTotalJurosManuais)} ({calculatedTotalJurosManuaisPercentual.toFixed(2)}%)</Typography>
                <Typography variant="body2" mb={0.5}><b>Desconto:</b> {formatCurrency(historicoPagamento.total_desconto || 0)} ({historicoPagamento.total_desconto_percentual !== undefined ? historicoPagamento.total_desconto_percentual.toFixed(2) : '0.00'}%)</Typography>
                <Typography variant="body2" mb={0.5}><b>Total Pago:</b> <span style={{color:'#1976d2'}}>{formatCurrency(historicoPagamento.total_pago || 0)}</span></Typography>
                <Typography variant="body2" mb={0.5}><b>Último Pagamento:</b> {historicoPagamento.pagamentos && historicoPagamento.pagamentos.length > 0 ? formatCurrency(historicoPagamento.pagamentos[historicoPagamento.pagamentos.length-1].valor_pago) : formatCurrency(0)}</Typography>
                <Typography variant="body2" mb={0.5}><b>Data do Último Pagamento:</b> {historicoPagamento.pagamentos && historicoPagamento.pagamentos.length > 0 ? formatDate(historicoPagamento.pagamentos[historicoPagamento.pagamentos.length-1].data_pagamento) : '-'}</Typography>
                <Typography variant="body2" mb={0.5}><b>Observações:</b> {historicoPagamento.parcela.observacoes || '-'}</Typography>
              </Box>
            </Box>
            {/* DESKTOP: Resumo tradicional */}
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <Typography variant="h6" gutterBottom style={{borderBottom: '1px solid #e0e0e0', paddingBottom: '8px', marginBottom: '16px'}}>Informações da Parcela</Typography>
              <Typography gutterBottom><b>Cliente:</b> {historicoPagamento.parcela.emprestimo?.cliente?.nome || 'N/A'}</Typography>
              <Typography gutterBottom><b>Parcela:</b> #{historicoPagamento.parcela.numero_parcela || historicoPagamento.parcela.numero || '?'}</Typography>
              <Typography gutterBottom><b>Valor Original:</b> {formatCurrency(historicoPagamento.parcela.valor_original || 0)}</Typography>
              <Box sx={{ backgroundColor: '#f5f5f5', padding: 2, borderRadius: 1, marginY: 2 }}>
                <Typography variant="subtitle1" gutterBottom><b>Detalhes de Juros e Descontos</b></Typography>
                <Typography gutterBottom><b>Juros Automáticos:</b> {formatCurrency(historicoPagamento.total_juros_automaticos || 0)} ({historicoPagamento.total_juros_automaticos_percentual !== undefined ? historicoPagamento.total_juros_automaticos_percentual.toFixed(2) : '0.00'}%)</Typography>
                <Typography gutterBottom><b>Juros Manuais:</b> {formatCurrency(historicoPagamento.juros_manuais_resumo !== undefined ? historicoPagamento.juros_manuais_resumo : calculatedTotalJurosManuais)} ({calculatedTotalJurosManuaisPercentual.toFixed(2)}%)</Typography>
                <Typography gutterBottom><b>Desconto:</b> {formatCurrency(historicoPagamento.total_desconto || 0)} ({historicoPagamento.total_desconto_percentual !== undefined ? historicoPagamento.total_desconto_percentual.toFixed(2) : '0.00'}%)</Typography>
              </Box>
              <Box sx={{ backgroundColor: '#e3f2fd', padding: 2, borderRadius: 1, marginY: 2 }}>
                <Typography variant="subtitle1" gutterBottom><b>Resumo do Pagamento</b></Typography>
                <Typography gutterBottom><b>Valor com Juros:</b> {formatCurrency((Number(historicoPagamento.parcela.valor_original || 0)
                  + Number(historicoPagamento.total_juros_automaticos || 0)
                  + Number(calculatedTotalJurosManuais)))}
                </Typography>
                <Typography gutterBottom><b>Valor após Descontos:</b> {formatCurrency((Number(historicoPagamento.parcela.valor_original || 0)
                  + Number(historicoPagamento.total_juros_automaticos || 0)
                  + Number(calculatedTotalJurosManuais)
                  - Number(historicoPagamento.total_desconto || 0)))}
                </Typography>
                <Typography gutterBottom><b><span style={{color:'#1976d2', fontSize: '1.1em'}}>Total Pago:</span></b> <span style={{color:'#1976d2', fontSize: '1.1em'}}>{formatCurrency(historicoPagamento.total_pago || 0)}</span></Typography>
                {/* Mostrar informações sobre saldo restante se estiver nas observações */}
                {historicoPagamento.parcela.observacoes && historicoPagamento.parcela.observacoes.includes('Saldo restante') && (
                  <Typography gutterBottom><b><span style={{color:'#f57c00'}}>Saldo Restante:</span></b> <span style={{color:'#f57c00'}}>
                    {formatCurrency(parseFloat(historicoPagamento.parcela.observacoes.match(/Saldo restante \(R\$ ([0-9.]+)\)/)?.[1] || 0))}
                  </span></Typography>
                )}
              </Box>
              <Box sx={{ marginY: 2 }}>
                <Typography gutterBottom><b>Último Pagamento:</b> {historicoPagamento.pagamentos && historicoPagamento.pagamentos.length > 0 ? formatCurrency(historicoPagamento.pagamentos[historicoPagamento.pagamentos.length-1].valor_pago) : formatCurrency(0)}</Typography>
                <Typography gutterBottom><b>Data do Último Pagamento:</b> {historicoPagamento.pagamentos && historicoPagamento.pagamentos.length > 0 ? formatDate(historicoPagamento.pagamentos[historicoPagamento.pagamentos.length-1].data_pagamento) : '-'}</Typography>
                <Typography gutterBottom style={{whiteSpace: 'pre-wrap'}}><b>Observações:</b> {historicoPagamento.parcela.observacoes || '-'}</Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          <Typography>Carregando histórico...</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: { xs: 1, sm: 2 } }}>
        <Button onClick={onClose} color="primary" fullWidth sx={{ fontSize: { xs: '1rem', sm: '1rem' }, py: 1 }}>
          FECHAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HistoricoPagamento;